module.exports = __webpack_public_path__ + "static/media/ukraine_flag.06c0ab93.jpg";